/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {
  SavedDashboard,
  SavedMenuPrimaryWidgetSettings,
} from 'pages/Home/DigitalCast/models/savedSpaceSettings';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

type CrWidgetDraft = {
  id: string;
  isChartEnabled: boolean;
  selectedInMenu: boolean;
  aGoalId: string;
  bGoalId: string;
};

/**
 * Подготовит данные дашборда для отправки на сервер
 * @param space
 */

const mapSavedSpace = (space: Space): SavedDashboard => {
  const primaryMap: Partial<Record<ChartIds, SavedMenuPrimaryWidgetSettings>> = {};

  // Собираем данные о включенных виджетах (switcher в положении ON)

  space.chartSelected.current.forEach(chartId => {
    if (primaryMap[chartId]) {
      primaryMap[chartId] = {
        ...primaryMap[chartId],
        isChartEnabled: true,
      };
    } else {
      primaryMap[chartId] = {
        id: chartId,
        isChartEnabled: true,
      };
    }
  });

  // Собираем данные о виджетах, которые помечены как отображаемые в дашборде

  space.widgetsBoardSelected.forEach(chartId => {
    if (primaryMap[chartId]) {
      primaryMap[chartId] = {
        ...primaryMap[chartId],
        selectedInMenu: true,
      };
    } else {
      primaryMap[chartId] = {
        id: chartId,
        selectedInMenu: true,
      };
    }
  });

  // Собираем данные о виджетах, которые помечены как отображаемые в меню

  space.widgetsMenuSelected.forEach(chartId => {
    if (primaryMap[chartId]) {
      primaryMap[chartId] = {
        ...primaryMap[chartId],
        showInMenu: true,
      };
    } else {
      primaryMap[chartId] = {
        id: chartId,
        showInMenu: true,
      };
    }
  });

  // Собираем положения кнопок сумма-день и масштаб

  const allChartIds = Object.keys(space.widgetsSettings) as ChartIds[];
  allChartIds.forEach(chartId => {
    const settings = space.widgetsSettings[chartId];
    const calcMethod = settings?.calcMethod;
    const isScaleChecked = settings?.isScaleChecked;
    if (primaryMap[chartId]) {
      primaryMap[chartId] = {
        ...primaryMap[chartId],
        ...(calcMethod ? {calcMethod} : {}),
        ...(isScaleChecked === undefined ? {} : {isScaleChecked}),
      };
    } else {
      primaryMap[chartId] = {
        id: chartId,
        ...(calcMethod ? {calcMethod} : {}),
        ...(isScaleChecked === undefined ? {} : {isScaleChecked}),
      };
    }
  });

  // CR виджеты: сохраняем выбранные показатели и состояние в меню

  const crIds = allChartIds.filter(id => String(id).startsWith('funnel_cr_'));

  const cr = crIds
    .map<CrWidgetDraft | null>(id => {
      const custom = space.widgetsSettings[id]?.custom;

      if (!custom?.aGoalId || !custom?.bGoalId) {
        return null;
      }
      return {
        id: String(id),
        isChartEnabled: space.chartSelected.current.includes(id),
        selectedInMenu: space.widgetsBoardSelected.includes(id),
        aGoalId: String(custom.aGoalId),
        bGoalId: String(custom.bGoalId),
      };
    })
    .filter((value): value is CrWidgetDraft => value !== null);

  return {
    title: space.title,
    order: space.order,
    menuWidgetSettings: {
      primary: Object.values(primaryMap),
      ...(cr.length ? {cr} : {}),
    },
  };
};

export default mapSavedSpace;
